<div id="services-container">
  <div id="content-container">
    <h1 class="card-header" *ngIf="ls.servicesHeader">
      {{ls.servicesHeader | translatedb | uppercase}}
    </h1>
    <div id="content" *ngIf="ls.servicesArticle" [innerHTML]="ls.servicesArticle | translatedb">
    </div>
  </div>
</div>
